import { render, staticRenderFns } from "./screctKey.vue?vue&type=template&id=8e90b284&scoped=true&"
import script from "./screctKey.vue?vue&type=script&lang=js&"
export * from "./screctKey.vue?vue&type=script&lang=js&"
import style0 from "./screctKey.vue?vue&type=style&index=0&id=8e90b284&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e90b284",
  null
  
)

export default component.exports